import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TeacherDashboard = () => {
  const navigate = useNavigate();
  const [selectedStudent, setSelectedStudent] = useState(null);

  // Mock student data
  const mockStudents = [
    { id: 1, name: 'Emma', age: 7, progress: 65, lastActivity: '2 hours ago' },
    { id: 2, name: 'Oliver', age: 8, progress: 80, lastActivity: '1 day ago' },
    { id: 3, name: 'Sophia', age: 9, progress: 45, lastActivity: '3 days ago' },
    { id: 4, name: 'Lucas', age: 10, progress: 90, lastActivity: '1 hour ago' }
  ];

  const recommendedActivities = [
    { id: 1, name: 'Animal Flashcards', ageGroup: '6-7', category: 'Vocabulary' },
    { id: 2, name: 'Simon Says', ageGroup: '6-7', category: 'Listening & Speaking' },
    { id: 3, name: 'Story Cubes', ageGroup: '10-11', category: 'Storytelling' }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      padding: '40px 20px',
      paddingTop: '100px'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '40px',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <h1 style={{
            fontSize: '48px',
            fontWeight: '800',
            color: '#DD2E44',
            margin: 0
          }}>
            👨‍🏫 Teacher Dashboard
          </h1>
          <button
            onClick={() => navigate('/dashboard/learning-hub')}
            style={{
              backgroundColor: 'white',
              color: '#DD2E44',
              padding: '12px 30px',
              borderRadius: '25px',
              border: '2px solid #DD2E44',
              fontSize: '18px',
              fontWeight: '700',
              cursor: 'pointer'
            }}
          >
            ← Back to Home
          </button>
        </div>

        {/* Overview Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '25px',
          marginBottom: '40px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '25px',
            boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>👥</div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DD2E44', marginBottom: '5px' }}>
              {mockStudents.length}
            </div>
            <div style={{ fontSize: '18px', color: '#666' }}>Total Students</div>
          </div>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '25px',
            boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📊</div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DD2E44', marginBottom: '5px' }}>
              70%
            </div>
            <div style={{ fontSize: '18px', color: '#666' }}>Average Progress</div>
          </div>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '25px',
            boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>⭐</div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DD2E44', marginBottom: '5px' }}>
              245
            </div>
            <div style={{ fontSize: '18px', color: '#666' }}>Total Stars Earned</div>
          </div>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '25px',
            boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>🎯</div>
            <div style={{ fontSize: '36px', fontWeight: '800', color: '#DD2E44', marginBottom: '5px' }}>
              48
            </div>
            <div style={{ fontSize: '18px', color: '#666' }}>Activities Completed</div>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '30px'
        }}>
          {/* Students List */}
          <div style={{
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '25px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
          }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '800',
              color: '#DD2E44',
              marginBottom: '30px'
            }}>
              Students
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {mockStudents.map((student) => (
                <div
                  key={student.id}
                  onClick={() => setSelectedStudent(student)}
                  style={{
                    padding: '20px',
                    backgroundColor: selectedStudent?.id === student.id ? '#FFF5F7' : '#F9F9F9',
                    borderRadius: '15px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: selectedStudent?.id === student.id ? '2px solid #DD2E44' : '2px solid transparent'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedStudent?.id !== student.id) {
                      e.currentTarget.style.backgroundColor = '#FFF5F7';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedStudent?.id !== student.id) {
                      e.currentTarget.style.backgroundColor = '#F9F9F9';
                    }
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}>
                    <div>
                      <div style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#DD2E44',
                        marginBottom: '5px'
                      }}>
                        {student.name}
                      </div>
                      <div style={{ fontSize: '16px', color: '#666' }}>
                        Age {student.age}
                      </div>
                    </div>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#DD2E44'
                    }}>
                      {student.progress}%
                    </div>
                  </div>
                  <div style={{
                    width: '100%',
                    height: '12px',
                    backgroundColor: '#F0F0F0',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    marginBottom: '10px'
                  }}>
                    <div style={{
                      width: `${student.progress}%`,
                      height: '100%',
                      backgroundColor: '#DD2E44',
                      borderRadius: '10px',
                      transition: 'width 0.3s ease'
                    }} />
                  </div>
                  <div style={{ fontSize: '14px', color: '#888' }}>
                    Last activity: {student.lastActivity}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recommended Activities */}
          <div style={{
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '25px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
          }}>
            <h2 style={{
              fontSize: '32px',
              fontWeight: '800',
              color: '#DD2E44',
              marginBottom: '30px'
            }}>
              Recommended Activities
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {recommendedActivities.map((activity) => (
                <div
                  key={activity.id}
                  style={{
                    padding: '20px',
                    backgroundColor: '#FFF5F7',
                    borderRadius: '15px',
                    border: '2px solid #F4ABBA'
                  }}
                >
                  <div style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#DD2E44',
                    marginBottom: '10px'
                  }}>
                    {activity.name}
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '15px',
                    fontSize: '14px',
                    color: '#666'
                  }}>
                    <span>👶 {activity.ageGroup}</span>
                    <span>📚 {activity.category}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Tips Section */}
            <div style={{
              marginTop: '40px',
              padding: '25px',
              backgroundColor: '#FFF5F7',
              borderRadius: '20px'
            }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#DD2E44',
                marginBottom: '15px'
              }}>
                💡 Teaching Tips
              </h3>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '16px',
                  color: '#666',
                  lineHeight: '1.6'
                }}>
                  • Keep sessions short (5-10 min) for younger kids
                </li>
                <li style={{
                  marginBottom: '12px',
                  fontSize: '16px',
                  color: '#666',
                  lineHeight: '1.6'
                }}>
                  • Use visual aids and movement for ages 6-7
                </li>
                <li style={{
                  fontSize: '16px',
                  color: '#666',
                  lineHeight: '1.6'
                }}>
                  • Encourage older kids (9-11) with challenges
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherDashboard;